import { render, staticRenderFns } from "./collapsed-menu.vue?vue&type=template&id=37d215bb&"
import script from "./collapsed-menu.vue?vue&type=script&lang=js&"
export * from "./collapsed-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports